import React from "react";
import { Box } from "@mui/material";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import Sidebar from "../Sidebar/Sidebar";
import LocalstorageHelper from "../../LocalStorageHelper/LocalstorageHelper";
import PurchaseApproveWorkspace from "../../Components/PurchaseApproveWorkspace/PurchaseApproveWorkspace";

const PurchaseReports = () => {
  const userToken = LocalstorageHelper.GetUserToken();

  const redirectToLoginPage = () => {
    if (!userToken) {
      return <Redirect exact to="/sparepartsLogin" />;
    }
  };

  return (
    <>
      <Sidebar
        Title={"Purchase Approve"}
        expandedPanel={"panel2"}
        children={
          <Box p={1}>
            <PurchaseApproveWorkspace token={userToken} />
          </Box>
        }
      />
      {redirectToLoginPage()}
    </>
  );
};

export default PurchaseReports;
